import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import SanitaireHero from './components/SanitaireHero';
import SanitaireGrid from './components/SanitaireGrid';
import SanitaireFeatures from './components/SanitaireFeatures';
import SEOHead from '@/components/feature/SEOHead';

const schema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Plombier Sanitaire Neuenegg - Salle de Bain Installation - CasaReNovaPlus",
  "provider": {
    "@type": "LocalBusiness",
    "name": "CasaReNovaPlus",
    "telephone": "+41797616282",
    "address": { "@type": "PostalAddress", "streetAddress": "Austrasse 95", "addressLocality": "Neuenegg", "addressRegion": "Fribourg", "postalCode": "3176", "addressCountry": "CH" },
    "geo": { "@type": "GeoCoordinates", "latitude": "46.233333", "longitude": "6.083333" },
    "openingHoursSpecification": [
      { "@type": "OpeningHoursSpecification", "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday"], "opens": "07:00", "closes": "19:00" },
      { "@type": "OpeningHoursSpecification", "dayOfWeek": ["Saturday","Sunday"], "opens": "00:00", "closes": "23:59" }
    ],
    "priceRange": "CHF"
  },
  "areaServed": ["Genève", "Meyrin", "Carouge", "Lancy", "Vernier", "Onex", "Thônex", "Lausanne", "Vaud", "Fribourg", "Valais", "Suisse Romande"],
  "description": "Plombier certifié à Genève. Installation salle de bain, dépannage plomberie urgence 24/7, détection fuite, rénovation sanitaire. Geberit, Hansgrohe, Grohe.",
  "serviceType": "Plomberie sanitaire salle de bain",
  "offers": { "@type": "Offer", "availability": "https://schema.org/InStock", "priceSpecification": { "@type": "PriceSpecification", "priceCurrency": "CHF", "description": "Devis gratuit" } },
  "url": `${import.meta.env.VITE_SITE_URL}/sanitaire`
};

export default function Sanitaire() {
  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="Plombier Neuenegg | Sanitaire Salle de Bain Dépannage 24/7 - CasaReNovaPlus"
        description="Plombier certifié à Genève. Installation salle de bain, dépannage plomberie urgence 24/7, détection fuite eau, rénovation sanitaire. Geberit, Hansgrohe, Grohe. Intervention Meyrin, Carouge, Lancy. Devis gratuit."
        keywords="plombier Genève, plombier urgence Genève, dépannage plomberie Genève, installation salle de bain Genève, rénovation salle de bain Genève, détection fuite eau Genève, sanitaire Genève, plombier Meyrin Carouge Lancy, Geberit Hansgrohe Genève, plombier 24h Genève, fuite eau urgence Genève, douche italienne Genève"
        canonical={`${import.meta.env.VITE_SITE_URL}/sanitaire`}
        schema={schema}
      />
      <Header />
      <SanitaireHero />
      <SanitaireGrid />
      <SanitaireFeatures />
      <Footer />
    </div>
  );
}
